import { useEffect, useState } from "react";
import { MessageCircle, MapPin, Phone, Calendar } from "lucide-react";
import { adminApi, mediaUrl } from "@/lib/api";

const Tab = ({ active, onClick, children }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 rounded-full text-xs uppercase tracking-widest font-bold transition-colors ${
      active ? "bg-[var(--fi-blue)] text-white" : "bg-white text-gray-500 border border-gray-200 hover:text-[var(--fi-blue)]"
    }`}
  >
    {children}
  </button>
);

const AdminMessages = () => {
  const [tab, setTab] = useState("complaints");
  const [complaints, setComplaints] = useState([]);
  const [reports, setReports] = useState([]);

  useEffect(() => {
    (async () => {
      const [c, r] = await Promise.all([
        adminApi.get("/admin/complaints"),
        adminApi.get("/admin/reports"),
      ]);
      setComplaints(c.data);
      setReports(r.data);
    })();
  }, []);

  const items = tab === "complaints" ? complaints : reports;

  return (
    <div>
      <div className="text-xs uppercase tracking-[0.28em] text-[var(--fi-red)] font-bold mb-1">
        Cidadão
      </div>
      <h1 className="font-display text-4xl sm:text-5xl font-black uppercase text-[var(--fi-blue)] leading-tight">
        Mensagens
      </h1>
      <div className="flex gap-2 mt-4">
        <Tab active={tab === "complaints"} onClick={() => setTab("complaints")}>
          Reclamações ({complaints.length})
        </Tab>
        <Tab active={tab === "reports"} onClick={() => setTab("reports")}>
          Pautas ({reports.length})
        </Tab>
      </div>

      <div className="mt-6 space-y-3">
        {items.length === 0 && (
          <div className="text-center py-16 text-gray-400 font-medium">Nenhuma mensagem ainda.</div>
        )}
        {items.map((m) => (
          <div key={m.id} className="rounded-xl bg-white p-4 shadow-[0_6px_20px_rgba(13,27,75,0.05)]">
            <div className="flex items-start justify-between flex-wrap gap-2">
              <div>
                <div className="font-display text-lg font-extrabold text-[var(--fi-blue)]">{m.name}</div>
                <div className="flex items-center gap-3 text-xs text-gray-500 mt-1 flex-wrap">
                  <span className="inline-flex items-center gap-1"><Phone className="w-3 h-3" /> {m.phone}</span>
                  {m.location && <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" /> {m.location}</span>}
                  {m.created_at && <span className="inline-flex items-center gap-1"><Calendar className="w-3 h-3" /> {new Date(m.created_at).toLocaleString("pt-BR")}</span>}
                </div>
              </div>
              {tab === "complaints" && (
                <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold bg-red-50 text-[var(--fi-red)] px-2.5 py-1 rounded-full">
                  <MessageCircle className="w-3 h-3" /> {m.complaint_type}
                </span>
              )}
            </div>
            <p className="mt-3 text-sm text-gray-700 whitespace-pre-wrap">{m.description}</p>
            {(() => {
              const src = m.photo_url || m.media_url;
              if (!src) return null;
              if (src.startsWith("data:image")) return <img src={src} alt="anexo" className="mt-3 rounded-lg max-h-48 object-cover" />;
              if (!src.startsWith("/api/media/")) return null;
              if (m.media_kind === "video") {
                return <video src={mediaUrl(src)} poster={m.media_thumb_url ? mediaUrl(m.media_thumb_url) : undefined} controls playsInline preload="metadata" className="mt-3 rounded-lg max-h-64 bg-black" data-testid={`message-video-${m.id}`} />;
              }
              return <a href={mediaUrl(src)} target="_blank" rel="noopener noreferrer"><img src={mediaUrl(src)} alt="anexo" loading="lazy" className="mt-3 rounded-lg max-h-48 object-cover" data-testid={`message-photo-${m.id}`} /></a>;
            })()}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminMessages;
